import Chance from 'chance';
import { getFakeSignature } from './get-fake-signature.js';
const chance = new Chance();
export const getFakeOther = (fieldType) => {
    let val;
    switch (fieldType) {
        case `signature`:
            val = getFakeSignature();
            break;
        case `rating`:
            val = chance.integer({
                min: 1,
                max: 5
            });
            break;
        case `user_roles`:
            val = [
                `all_users`
            ];
            break;
        default:
            val = {
                label: `link`,
                url: chance.url({
                    protocol: `https`
                })
            };
            break;
    }
    return val;
};
